import { START_LOADING,END_LOADING, FETCH, CREATE,UPDATE, DELETE , ACTION, FETCH_ALL,  SET_ERROR, CLEAR_ERROR, GET_ERROR, FETCH_BY_ID, RESET, UPDATE_MULTIPART, TRANSACTION} from '../constants/actionTypes';

const initialState = {
    transaction:[],
    transactions:[],
    isLoading: false,
    error: null
};

const transactionReducer = (state = initialState,action) =>{
    if(action?.payload?.type === TRANSACTION ){
        switch (action.type){
            case GET_ERROR:
                return {...state,error: null};
            case CLEAR_ERROR:
                return { ...state, error: null};
            case SET_ERROR:
                return { ...state,  error: action.payload.error};
            case START_LOADING:
                return {...state, isLoading:true}
            case END_LOADING:
                return {...state, isLoading:false};
            case FETCH: 
                return {...state, transaction: action.payload.data};
            case FETCH_ALL: 
                return {...state, transactions: action.payload.data};
            case FETCH_BY_ID: 
                return {...state, transaction: action.payload.data};      
            case CREATE:
                return { ...state, transaction: [...state.transaction, action.payload] };
            case UPDATE:
                return {...state, transaction: state.transaction._id === action.payload.data._id ? { ...state.transaction, ...action.payload.data } : state.transaction };
            case UPDATE_MULTIPART:
                return {...state, transaction: state.transaction._id === action.payload.data._id ? { ...state.transaction, ...action.payload.data } : state.transaction };
            case DELETE:
                return {...state, transaction: state.transaction.map((transaction) => transaction._id !== action.payload) };
            case ACTION:
                return {...state, transaction:  action.payload.data};
            case RESET:
                return initialState;
            default:
                return state;
            }
    }
    else{
        return state;
    }
};
export default transactionReducer;